import { makeLink } from "./links";
import { urls, contactEmail } from "./urls";
import { type FAQ } from "./FAQ.en";
import { get } from "svelte/store";

export const faq = (): FAQ => ({
  title: "PROMOCIÓN LITTLE CAESARS® X CALL OF DUTY®",
  subtitle: "PREGUNTAS MÁS FRECUENTES",
  q: "P:",
  a: "R:",
  qaList: [
    {
      question: "¿Has experimentado un error técnico en el sitio web de la promoción?",
      answer: [{
        type: "string",
        content: `Por favor intenta borrar el caché, actualizar la página, o abrir una nueva ventana en otro navegador. Si sigues teniendo problema con la promoción, envíanos un correo a ${makeLink(get(urls).contactUs, contactEmail)} e incluye la captura de pantalla, información del navegador/dispositivo y un mensaje detallado sobre tu problema.`
      }]
    },
    {
      question: "¿Quién es elegible para esta promoción?",
      answer: [{
        type: "string",
        content: `El Sorteo Little Caesars x Call of Duty está abierto para residentes legales en uno (1) de los cincuenta (50) Estados Unidos o el Distrito de Columbia, Canadá (excluyendo Quebec) y México que tengan dieciocho (18) años o mayores al momento/fecha de la inscripción. Puedes consultar detalles en las ${makeLink(get(urls).officialRules, "Reglas Oficiales")}.`
      }]
    },
    {
      question: "¿Debo registrar y vincular mi cuenta Activision cada vez que quiero participar?",
      answer: [{
        type: "string",
        content: `Se te pedirá que te registres y vincules tu cuenta Activision con cada participación. Sin embargo, tu dispositivo puede omitir la autenticación de Activision si ya lo hiciste en las últimas 24 horas.`
      }]
    },
    {
      question: "¿Qué se entiende por “Compra Válida” para desbloquear recompensas en el juego?",
      answer: [{
        type: "string",
        content: `Es un pedido en restaurante o en línea de cualquier producto de alimento o bebida de una tienda de Little Caesars que cumpla los siguientes subtotales mínimos (antes de impuestos/tasas) en los siguientes países:`
      }, {
        type: "list",
        content: [
          `Estados Unidos: $3 USD`,
          `Canadá: $4.99 CAD`,
          `México: $50 MXN`
        ]
      },
      {
        type: "string",
        content: `Los pedidos en sitios de entrega de terceros y Kmart, estadio y Little Caesars Express y locales de concepto no califican para las recompensas en el juego.`
      },
      {
        type: "string",
        content: `No se necesita una “Compra Válida” para participar. Ver las ${makeLink(get(urls).officialRules, "Reglas Oficiales")} para saber cómo participar sin una compra.`
      }]
    },
    {
      question: "¿Cómo participo para recompensas en el juego y premios?",
      answer: [{
        type: "string",
        content: `Para Compras Válidas en restaurante en Estados Unidos, recibirás un código en la parte inferior de tu recibo impreso. Ingresa este código en este sitio para desbloquear la recompensa o premio. Si, por alguna razón, un código no se imprime en el recibo de tu compra válida en restaurante, por favor contacta al servicio al cliente de Little Caesars en ${makeLink(get(urls).contactLittleCaesars, "Contáctanos - Little Caesars®")}.`
      }, {
        type: "string",
        content: `Para Compras Válidas en restaurantes en Canadá y México, recibirás un código en la parte inferior de tu recibo impreso. Ingresa este código en este sitio para desbloquear la recompensa o premio. Si, por alguna razón, un código no se imprime en el recibo de tu Compra Válida en restaurante, puedes cargar una foto de tu recibo en este sitio para verificación. La recompensa o premio será desbloqueada una vez que tu recibo sea verificado. Los cargos de recibos con códigos serán rechazados.`
      }, {
        type: "string",
        content: `Para instrucciones sobre cómo participar sin una compra, consulta las ${makeLink(get(urls).officialRules, "Reglas Oficiales")}.`
      }, {
        type: "string",
        content: `A los participantes en México y Canadá se les solicitará respondan correctamente una pregunta de habilidad para que puedan recibir una recompensa o premio.`
      }]
    },
    {
      question: "¿Qué puedo ganar?",
      answer: [{
        type: "string",
        content: `Puedes desbloquear uno de los siguientes premios o recompensas con cada participación elegible para mejorar la experiencia en el juego en <i>Call of Duty: Black Ops 7</i>, seleccionado al azar en el momento de la inscripción.`
      }, {
        type: "string",
        content: `Premios (límite total 2 por persona):`
      }, {
        type: "list",
        content: [
          "Pase de Batalla + 15 minutos de Dual 2XP",
          "Puntos Call of Duty en las siguientes cantidades: 500, 1100, 2400 y 13000 (importes concedidos al azar) + 15 minutos de Dual 2XP"
        ]
      }, {
        type: "string",
        content: `Recompensas:`
      }, {
        type: "list",
        content: [
          "Skin del Operador + 30 minutos de Dual 2XP",
          "Emblema + 30 minutos de Dual 2XP",
          "Charm + 30 minutos de Dual 2XP",
          "Calling Card + 30 minutos de Dual 2XP",
          "1 hora de Dual 2XP"
        ]
      }]
    },
    {
      question: "¿Puedo desbloquear el mismo artículo varias veces?",
      answer: [{
        type: "string",
        content: `Hay una probabilidad que tu participación pueda desbloquear el mismo artículo varias veces. Si desbloqueas la recompensa de Skin del Operador, Calling Card, Emblema o Charm, (recompensas “Little Caesars”) o el premio de Pase de Batalla más de una vez, estos artículos únicamente serán aplicados a tu cuenta Activision la primea vez. Si desbloqueas estos artículos en otro momento, recibirás sólo el nivel Dual 2XP en el juego.`
      }, {
        type: "string",
        content: `Límite de 2 premios totales por persona. Puedes seguir participando una vez al día para desbloquear recompensas adicionales incluso después de haber alcanzado el límite de premios. Máximo 40 horas de Dual 2XP totales que aplican a ambos premios y recompensas de todas las promociones Dual 2XP para <i>Call of Duty: Black Ops 7</i> anyd Call of Duty: Warzone™ (no limitado a esta promoción).`
      }]
    },
    {
      question: "¿Cuántas veces puedo participar al día?",
      answer: [{
        type: "string",
        content: `Puedes participar hasta una vez al día.`
      }]
    },
    {
      question: "¿Cuándo recibiré mi recompensa o premio?",
      answer: [{
        type: "string",
        content: `Tu recompensa o premio se entregará dentro de 48 horas. Los detalles específicos sobre tu recompensa o premio que hayas ganado serán enviados a tu correo electrónico inmediatamente después de la participación.`
      }]
    },
    {
      question: "¿Qué debo hacer si no veo mi recompensa de Pase de Batalla, Dual 2XP, o Little Caesars en el juego?",
      answer: [{
        type: "string",
        content: `Si iniciaste sesión en el juego cuando enviaste tu código o cuando tu recibo fue verificado, intenta reiniciar el juego para recibir tu contenido digital. Si tus recompensas de Pase de Batalla, Dual 2XP, o Little Caesars aún no aparecen, por favor contacta a ${makeLink(get(urls).activisionSupport, "Soporte Activision")} para recibir ayuda. Toma en cuenta que el Pase de Batalla será entregado en el juego al inicio de la Temporada 1 de <i>Call of Duty: Black Ops 7</i>, que llegará a finales de año.`
      }]
    },
    {
      question: "He recibido un código por correo electrónico para Call of Duty Points. ¿Dónde puedo canjearlo?",
      answer: [{
        type: "string",
        content: `Debes iniciar sesión en la cuenta de origen de su plataforma para introducir el código:`
      }, {
        type: "list",
        content: [
          `Xbox®: ${makeLink("https://www.xbox.com/redeem")}`,
          `PlayStation®: ${makeLink("https://www.playstation.com/")} (selecciona el ícono de perfil)`,
          `Battle.net: ${makeLink("https://us.shop.battle.net/")} (selecciona el perfil en la parte superior derecha)`,
          `Steam: ${makeLink("https://www.callofduty.com/redeem")}`,
          `Xbox on PC: ${makeLink("https://www.xbox.com/redeem")}`
        ]
      }, {
        type: "string",
        content: `Si tienes problemas para canjear los puntos Call of Duty y has iniciado sesión en el juego al introducir el código, reinicia el juego para recibir el contenido digital.`
      }]
    },
    {
      question: "¿Cuánto dura la promoción?",
      answer: [{
        type: "string",
        content: `Las Compras Válidas se deben realizar entre el 3 de noviembre de 2025 a las 12:00:01 am TE y el 31 de diciembre de 2025 a las 11:59:59 pm TE, y deben ser enviadas antes del 31 de enero de 2026 a las 11:59:59 pm TE para que se puedan desbloquear recompensas y premios.`
      }]
    },
    {
      question: "¿Nos ves aquí tu pregunta o problema?",
      answer: [{
        type: "string",
        content: `Por favor envía un correo a: ${makeLink(get(urls).contactUs, contactEmail)}.`
      }]
    }
  ],
  footnote: `EN CASO DE DISCREPANCIA O INCOHERENCIA ENTRE LAS DIVULGACIONES U OTRAS DECLARACIONES CONTENIDAS EN ESTAS FAQS Y LOS TÉRMINOS Y CONDICIONES DE LAS ${makeLink(get(urls).officialRules, "REGLAS OFICIALES")}, LAS ${makeLink(get(urls).officialRules, "REGLAS OFICIALES")} PREVALECERÁN, REGIRÁN Y CONTROLARÁN.`
});
